export var FormResolution;
(function (FormResolution) {
    FormResolution["HOTEL_CARD_DESKTOP"] = "280x220";
    FormResolution["HOTEL_CARD_DESKTOP2X"] = "560x440";
    FormResolution["HOTEL_CARD_MOBILE"] = "168x118";
    FormResolution["HOTEL_CARD_MOBILE2X"] = "336x236";
    FormResolution["HOTEL_CARD_TABLET"] = "270x260";
    FormResolution["HOTEL_CARD_TABLET2X"] = "540x520";
})(FormResolution || (FormResolution = {}));
var ImageHelper = /** @class */ (function () {
    function ImageHelper() {
    }
    ImageHelper.prototype.cropImgForDeviceResolution = function (url, formFactor, webp) {
        if (webp) {
            return this.toWebPUrl(url.indexOf('{size}') !== -1 ? url.replace('{size}', formFactor) : url);
        }
        else {
            return url.indexOf('{size}') !== -1 ? url.replace('{size}', formFactor) : url;
        }
    };
    ImageHelper.prototype.toWebPUrl = function (url) {
        return url.replace('/scalr/', "/scalr-webp/");
    };
    return ImageHelper;
}());
export { ImageHelper };
export default ImageHelper;
